/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_translate_length = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Length: ${i?.n} amino acids`)
};

const es_translate_length = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Longitud: ${i?.n} aminoácidos`)
};

const de_translate_length = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Länge: ${i?.n} Aminosäuren`)
};

const nl_translate_length = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lengte: ${i?.n} aminozuren`)
};

const fr_translate_length = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Longueur : ${i?.n} acides aminés`)
};

const it_translate_length = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lunghezza: ${i?.n} amminoacidi`)
};

const pt_br2_translate_length = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comprimento: ${i?.n} aminoácidos`)
};

const pt_translate_length = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comprimento: ${i?.n} aminoácidos`)
};

const ja_translate_length = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`長さ: ${i?.n} アミノ酸`)
};

const zh_translate_length = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`长度：${i?.n} 个氨基酸`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ n: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const translate_length = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.translate_length(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("translate_length", locale)
	if (locale === "en") return en_translate_length(inputs)
	if (locale === "es") return es_translate_length(inputs)
	if (locale === "de") return de_translate_length(inputs)
	if (locale === "nl") return nl_translate_length(inputs)
	if (locale === "fr") return fr_translate_length(inputs)
	if (locale === "it") return it_translate_length(inputs)
	if (locale === "pt-BR") return pt_br2_translate_length(inputs)
	if (locale === "pt") return pt_translate_length(inputs)
	if (locale === "ja") return ja_translate_length(inputs)
	return zh_translate_length(inputs)
};